import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-1.5">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
          )}
          {item.href && index < items.length - 1 ? (
            <Link to={item.href} className="hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
              {item.label}
            </Link>
          ) : (
            <span className={index === items.length - 1 ? 'text-foreground-800 font-medium' : 'text-foreground-500'}>
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}